import Vue from 'vue'
import Vuex from 'vuex'
import ajaxData from './ajaxData'
import request from '@/utils/request'
import request_up from '@/utils/request_up'
import { getToken, removeToken } from '@/utils/auth'
import {logout, getInfo} from '@/api/index'
Vue.use(Vuex)

const state = {
  vuex_h5: !!navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i),
  token: getToken(),
  name: '',
  avatar: '',
  roles: [],
  permissions: [],
  userInfo: {} // 添加用户信息对象
}
// const getters = {
//   // ... 其他 getters
//   userInfo: state => {
//     console.log(state,'state---')
//     return state.userInfo
//   }
// }
const mutations = {
  // ... 现有代码 ...
  
  SET_USER_INFO: (state, userInfo) => {
    console.log(userInfo,'553904----')
    state.userInfo = userInfo
    console.log(state.userInfo,'553111904----')
  }
}

const actions = {
  // 异步请求
  callInterface(_, { url, method, pathVar, data, params, headers, hasToken, responseType }) {
    url = pathVar ? url.replace('{pathVar}', pathVar) : url
    url += ajaxData.generateQueryParams(params)
    headers = method === 'get' ? headers || {} : headers || ajaxData.generatePostHeaders()
    return new Promise((resolve, reject) => {
      request({ method, url, headers, data, hasToken, responseType })
        .then((res) => {
          const { code } = res
          if (code === 200) {
            resolve(res)
          } else {
             reject(res.msg)
            // if (!code && res) {
            //   resolve(res)
            // }
          }
        })
        .catch((err) => {
          //  定义默认错误类型，加上code
          const defaultErr = { code: 50000, message: '网络错误' }
          if (err && err.response) {
            const errData = err.response.data || defaultErr
            reject(errData)
          }
        })
    })
  },
   // 异步请求
  callInterface_up(_, { url, method, pathVar, data, params, headers, hasToken, responseType }) {
    url = pathVar ? url.replace('{pathVar}', pathVar) : url
    url += ajaxData.generateQueryParams(params)
    headers = method === 'get' ? headers || {} : headers || ajaxData.generatePostHeaders()
    return new Promise((resolve, reject) => {
      request_up({ method, url, headers, data, hasToken, responseType })
        .then((res) => {
          const { code } = res
          if (code === 200) {
            resolve(res)
          } else {
             reject(res.msg)
            // if (!code && res) {
            //   resolve(res)
            // }
          }
        })
        .catch((err) => {
          //  定义默认错误类型，加上code
          const defaultErr = { code: 50000, message: '网络错误' }
          if (err && err.response) {
            const errData = err.response.data || defaultErr
            reject(errData)
          }
        })
    })
  },
  // 获取用户信息
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo().then(res => {
        console.log(res,'res--')
        const { data } = res
        if (!data) {
          reject('验证失败，请重新登录。')
        }
        
    
        commit('SET_USER_INFO', data) // 保存完整的用户信息
        
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  // 登出
  logout({ commit}) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_PERMISSIONS', [])
        commit('SET_USER_INFO', {}) // 清空用户信息
        
        removeToken()
        
        // // 重置访问的视图和缓存的视图
        // dispatch('tagsView/delAllViews', null, { root: true })
        
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}
const store = new Vuex.Store({
  actions,
  state,
  mutations,
  // getters
})
console.log(store,'store--')
export default store
